import { updateProvinceRequest } from "../../data/provinceApi";
import { validateProvincePayload } from "../validator/validateProvincePayload";

export async function updateProvinceUseCase(payload) {
  const error = validateProvincePayload(payload);

  if (error) {
    throw new Error(error);
  }

  if (!payload?.id) {
    throw new Error("El id es obligatorio.");
  }

  return await updateProvinceRequest(payload);
}
